import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section aria-labelledby="instant-title" className="bg-white px-5 py-20 md:py-28" data-id="element-152" data-mp="1meiwu1ubboit">
      <Reveal className="mx-auto max-w-3xl" data-id="element-153" data-mp="1ho2hudaufuuc">
        <div className="text-center" data-id="element-154" data-mp="1hnakoy1llp1y">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber" data-id="element-155" data-mp="1hm98urcrcyj6">INSTANT ACCESS</p>
          <h2 id="instant-title" className="mt-4 text-3xl font-extrabold tracking-tight text-pine md:text-4xl" data-id="element-156" data-mp="1wet5ra9be9s6">
            What You Get Right Now
          </h2>
        </div>
        <ul className="mt-12 divide-y divide-slate-line rounded-card border border-slate-line bg-white px-6 shadow-card md:px-8" data-id="element-157" data-mp="25cvfce746ar2">
          {instantAccessItems.map(item => <li key={item} className="flex items-start gap-4 py-5" data-id="element-158" data-mp="b0f38wrn02ea">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-turquoise text-white" data-id="element-159" data-mp="612eg6h7gl92">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-160" data-mp="2n2zullzvls7w" />
              </span>
              <span className="text-sm font-medium leading-snug text-ink md:text-base" data-id="element-161" data-mp="2s19qxzxc6yv3">{item}</span>
            </li>)}
        </ul>
        <p className="mt-10 text-center font-display text-xl font-bold italic text-pine md:text-2xl" data-id="element-162" data-mp="31qkwjcl0lle8">
          You will never walk onto the field empty-handed again.
        </p>
      </Reveal>
    </section>;
}